import React from 'react';
import { Link } from 'react-router-dom';
import { T, useI18n } from '@tribeplatform/react-components/i18n';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { EmptyState } from '@tribeplatform/react-ui-kit/EmptyState';
export const PostNotFound = () => {
    const { $t } = useI18n();
    return (React.createElement(Card, null,
        React.createElement(Card.Content, null,
            React.createElement("div", { className: "py-12" },
                React.createElement(EmptyState, { title: $t({
                        id: 'Blocks.Post.NotFoundTitle',
                        defaultMessage: 'Post not found',
                    }), description: $t({
                        id: 'Blocks.Post.NotFoundDescription',
                        defaultMessage: 'This post does not exist, is removed, or you don’t have permission to access it.',
                    }) },
                    React.createElement(Button, { variant: "outline", as: Link, to: "/" },
                        React.createElement(T, { id: "Generics.Home", defaultMessage: "Home" })))))));
};
//# sourceMappingURL=PostNotFound.js.map